import React, { useContext } from 'react';
import { useTheme, TableRow } from '@mui/material';
import { map } from 'lodash-es';
import InfoCardWrapper from 'components/reviewResultsPage/common/wrappers/infoCardWrapper';
import InfoCardHeader from 'components/reviewResultsPage/common/header/infoCardHeader';
import InfoCardContentWrapper from 'components/reviewResultsPage/common/wrappers/infoCardContentWrapper';
import TableWrapper from 'components/reviewResultsPage/common/cardLists/table/tableWrapper';
import TableHeaderWrapper from 'components/reviewResultsPage/common/cardLists/table/tableHeaderWrapper';
import TableCellWrapper from 'components/reviewResultsPage/common/cardLists/table/tableCellWrapper';
import TableBodyWrapper from 'components/reviewResultsPage/common/cardLists/table/tableBodyWrapper';
import { getScoreBorderStyles } from 'components/reviewResultsPage/common/cardLists/table/_helpers';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'mobx/mobxContext';
import { adaptIntersectionsData } from 'mobx/employeeForm/_adapters';
import { v4 as uuidv4 } from 'uuid';

export default observer(function Top10IntersectionsCard() {
  const theme = useTheme();

  const {
    mobxStore: { employeeFormStore },
  } = useContext(MobxContext);

  const { intersectionsData } = employeeFormStore;

  if (!intersectionsData) {
    return null;
  }

  const headerLabels = ['СОТРУДНИК', 'КОЛИЧЕСТВО ОЦЕНОК'];
  const rowsData = adaptIntersectionsData(intersectionsData);

  return (
    <InfoCardWrapper>
      <InfoCardHeader
        mainText="ТОП 10 ПЕРЕСЕЧЕНИЙ"
        mainTextSecondLine="(оценили меня по количеству)"
        bgColor={theme.palette.custom.infoCardHeaderColor}
      />

      <InfoCardContentWrapper>
        <TableWrapper>
          <TableHeaderWrapper>
            <TableCellWrapper
              key={uuidv4()}
              text="№"
              cellSx={{
                borderTop: 2,
                borderTopColor: theme.palette.custom.darkGray,
              }}
            />

            {map(headerLabels, (label) => (
              <TableCellWrapper
                key={uuidv4()}
                text={label}
                cellSx={{
                  borderLeft: 2,
                  borderLeftColor: theme.palette.custom.darkGray,
                }}
              />
            ))}
          </TableHeaderWrapper>

          <TableBodyWrapper>
            {map(rowsData, (rowItem, index) => (
              <TableRow key={uuidv4()}>
                <TableCellWrapper
                  key={uuidv4()}
                  text={index + 1}
                  cellSx={{
                    borderTop: 2,
                    borderTopColor: theme.palette.custom.darkGray,
                  }}
                />

                {map(rowItem, (text, objectKey) => {
                  const scoreBorder =
                    objectKey === 'score' ? getScoreBorderStyles() : undefined;
                  const align = objectKey === 'mainText' ? 'left' : 'center';

                  return (
                    <TableCellWrapper
                      key={uuidv4()}
                      text={text}
                      align={align}
                      typographySx={scoreBorder}
                      cellSx={{
                        borderLeft: 2,
                        borderLeftColor: theme.palette.custom.darkGray,
                        borderTop: 2,
                        borderTopColor: theme.palette.custom.darkGray,
                      }}
                    />
                  );
                })}
              </TableRow>
            ))}
          </TableBodyWrapper>
        </TableWrapper>
      </InfoCardContentWrapper>
    </InfoCardWrapper>
  );
});
